import React, { useState, useEffect } from 'react';
import { PickList } from 'primereact/picklist';
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import GroupsDropdown from './GroupsDropdown';
import CommonNav from './CommonNav'
import { Endpoints } from "../constants/env/middletier";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';

function ManageGroups() {
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);
    const [allSubs, setAllSubs] = useState([]);
    const [groupName, setGroupName] = useState("");
    const [newGroupName, setNewGroupName] = useState("");
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('center');

    const dropdownRef = React.useRef()


    const onChange = (event) => {
        console.log(event)
        setSource(event.source);
        setTarget(event.target);
    };
    const sortByName = (a, b) => a.fullName.localeCompare(b.fullName);

    useEffect(() => {
        async function fetchGroups() {
            const response = await fetch(Endpoints["subs"], {
                method: "GET"
            });
            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
            const newSource = [...data].sort(sortByName);

            setSource(newSource);
            setAllSubs(newSource);
            console.log(data);
        }
        fetchGroups();
    }, []);

    const handleGroupName = async (name) => {
        setGroupName(name.value);
    };

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                <div className="flex-1 flex flex-column gap-2">
                    <span className="font-bold">{item.fullName}</span>
                </div>
            </div>
        );
    };

    const handleGroupsDropdownChange = async (data) => {
        console.log("Setting group dropdown");
        console.log(data);
        const value = data;
        console.log(data);
        setSelectedGroup(value);
        console.log("value");
        console.log(value);

        try {
            const response = await fetch(Endpoints["getsubsbygroup"] + `${value.groupName}/phones`, {
                method: "GET"
            });
            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
//            setResult(data);
//            setSelectedSubs(data);
            console.log("getting group subs");
            console.log(data);

            setTarget(data);


            const unavailableIds = new Set(data.map(u => u.id));

            const filtered = allSubs.filter(sub => !unavailableIds.has(sub.id));
            setSource(filtered);


        } catch (err) {
            console.error(err);
        }


    };


    const handleCreateGroup = async () => {
        console.log("handleAddGroup");
        console.log(newGroupName);

        if (newGroupName === null) throw new Error("Please add a group name");


        const payload = {
            name: newGroupName,
            description: newGroupName
        };

        try {
            const response = await fetch(Endpoints["createsubgroup"], {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            console.log("Success:", result);



            console.log(dropdownRef);
            console.log(dropdownRef.current);
            await dropdownRef.current.reset();
            setVisible(false);
        } catch (error) {
          console.error("Error sending messages:", error);
        }
    };

    const handleAddSubsToGroup = async () => {
        console.log("handleAddSubsToGroup");
        console.log(target);

        if (target === null || target.length < 1) throw new Error("No subs to add to group");

        const subGroupMembershipIds = target.map(p => ({
            substituteId: p.id,
            groupId: selectedGroup.id
        }));


        console.log("subGroupMembershipIds");
        console.log(subGroupMembershipIds);

        try {
          const response = await fetch(Endpoints["createsubgroupmembership"], {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(subGroupMembershipIds),
          });
          console.log("Request sent");
          const result = await response.json();
          console.log("Success:", result);
        } catch (error) {
          console.error("Error sending messages:", error);
        }
    };




    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };


    const groupNameFooter = (
        <>
            <Button label="Add New Group" icon="pi pi-plus" tooltip="Add New Group" rounded text aria-label="Add"
                onClick={() => show('top')} severity="secondary" />
            <Dialog header="Add New Group" visible={visible} position={position} style={{ width: '25vw' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                <div className="card flex flex-wrap justify-content-center gap-3">
                    <br />
                    <FloatLabel>
                        <InputText id="group_name" value={newGroupName} onChange={(e) => setNewGroupName(e.target.value)} style={{ width: '20vw' }} />
                        <label htmlFor="group_name">New Group Name</label>
                    </FloatLabel>
                    <Button label="Submit" icon="pi pi-check" onClick={handleCreateGroup} />
                </div>

            </Dialog>
        </>
    );

    const groupListFooter = (
        <>
            <Button label="Save Changes" icon="pi pi-plus" tooltip="Add New Group" rounded text aria-label="Add"
                onClick={handleAddSubsToGroup} severity="secondary" />
        </>
    );


    return (
        <>
        <CommonNav></CommonNav>
        <br />
        <br />
        <br />
        <div class="flex flex-column">
            <div class="flex align-items-center justify-content-center h-40rem bg-primary font-bold border-round m-2">
                <Card title="Edit Group" className="lg:w-40rem" footer={groupNameFooter}>
                    <GroupsDropdown onGetGroup={handleGroupsDropdownChange} ref={dropdownRef} />
                </Card>
            </div>
            <div class="flex align-items-center justify-content-center h-40rem bg-primary font-bold border-round m-2">
                {selectedGroup && <Card title="Select Subs to Add to Group" className="lg:w-40rem" footer={groupListFooter}>
                    <div className="flex gap-5 justify-content-end">
                        <div className="card">
                            <PickList dataKey="id" source={source} target={target} onChange={onChange} filter filterBy="fullName" itemTemplate={itemTemplate} breakpoint="1280px"
                                showSourceControls={false}
                                showTargetControls={false}
                                sourceHeader="Unassigned" targetHeader="Assigned to Group" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }} />
                        </div>
                    </div>
                </Card>}
            </div>
        </div>
        </>
    );
}

export default ManageGroups;